import { formatDate } from './format'

/**
 * Source citations for journalists (DESIGN.md → Del og eksportér): name,
 * identifier, source and the date the data was read, plus the page link.
 *
 *   »Nordlys Rederi ApS (CVR 41 27 83 90). Kilde: CVR-registret,
 *    Erhvervsstyrelsen, hentet 26. okt. 2026 via Xosa Origin: https://…«
 */

/** CVR in pairs, as printed in Danish registers: »41 27 83 90«. */
export function formatCvrSpaced(cvr: string | number | null | undefined): string {
  const digits = String(cvr ?? '').replace(/\D/g, '')
  if (digits.length !== 8) return String(cvr ?? '').trim()
  return digits.replace(/(\d{2})(?=\d)/g, '$1 ')
}

function citation(subject: string, url: string, readAt: Date): string {
  const date = formatDate(readAt.toISOString()) ?? ''
  return `${subject}. Kilde: CVR-registret, Erhvervsstyrelsen, hentet ${date} via Xosa Origin: ${url}`
}

export function companySourceCitation(
  name: string,
  cvr: string | number,
  url: string,
  readAt: Date = new Date(),
): string {
  return citation(`${name} (CVR ${formatCvrSpaced(cvr)})`, url, readAt)
}

export function personSourceCitation(
  name: string,
  enhedsNummer: string | number,
  url: string,
  readAt: Date = new Date(),
): string {
  return citation(`${name} (enhedsnr. ${enhedsNummer})`, url, readAt)
}
